import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/vgt.css";
import { installHorchen } from "./lib/installieren";
import App from "./App";
import { MUpdateBalken, bootTheme } from "@vimaana/ui";

// Thema setzen, bevor React rendert — sonst blitzt kurz das falsche auf.
bootTheme();

// Das Installations-Angebot des Browsers kommt frueh und verfaellt, wenn es
// niemand abfaengt — deshalb vor dem Render.
installHorchen();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <>
        {/* Meldet sich nur, wenn wirklich ein neuerer Stand ausgeliefert ist. */}
        <MUpdateBalken />
        <App />
      </>
    </QueryClientProvider>
  </React.StrictMode>,
);
